import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasProduct, HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import truncate from "lodash/truncate";
import React, { useState } from "react";
import { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        productsDataView: getProductListDataView(state),
    };
};

const enum fields {}

interface OwnProps extends WidgetProps {
    fields: {};
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasProduct & HasProductContext;

export interface ProductDetailAdditionalInfoStyles {
    mainContainer?: InjectableCss;
    infoStyles?: InjectableCss;
    linkStyles?: InjectableCss;
    noTruncatedStyles?: InjectableCss;
    truncatedStyles?: InjectableCss;
}

export const productDetailAdditionalInfoStyles: ProductDetailAdditionalInfoStyles = {
    mainContainer: {},
    linkStyles: {
        css: css`
            span {
                font-family: Poppins;
                font-size: 12px;
                font-weight: 600;
                line-height: 16px;
                text-align: left;
                margin-top: 8px;
            }
        `,
    },
    truncatedStyles: {
        css: css`
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: ${getColor("text.main")};
            ul {
                margin: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px 0px 0px 21px;
                        `,
                        css`
                            padding: 0px 0px 0px 21px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
    noTruncatedStyles: {
        css: css`
            display: block;
            -webkit-box-orient: unset;
            -webkit-line-clamp: unset;
            overflow: visible;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: ${getColor("text.main")};
            ul {
                margin: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px 0px 0px 21px;
                        `,
                        css`
                            padding: 0px 0px 0px 21px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
};

const styles = productDetailAdditionalInfoStyles;

export const CENProductDetailsAdditionalInfo: FC<Props> = ({ productContext }) => {
    const [truncated, setTruncate] = useState(true);
    const toggleStatus = () => {
        setTruncate(!truncated);
    };

    if (!productContext?.product?.properties?.additionalInfo) {
        return null;
    }

    return (
        <StyledWrapper {...styles.mainContainer}>
            {!getIsWebCrawler() && truncated ? (
                <Typography {...styles.truncatedStyles}>
                    {parse(productContext?.product?.properties?.additionalInfo, parserOptions)}
                </Typography>
            ) : (
                <Typography {...styles.noTruncatedStyles}>
                    {parse(productContext?.product?.properties?.additionalInfo, parserOptions)}
                </Typography>
            )}
            {productContext?.product?.properties?.additionalInfo.length > 350 && !getIsWebCrawler() && (
                <Link href="" onClick={toggleStatus} {...styles.linkStyles}>
                    {truncated ? "Show More" : "Show Less"}
                </Link>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(withProductContext(CENProductDetailsAdditionalInfo)),
    definition: {
        group: "Basic",
        displayName: "CEN PDP AdditonalInfo",
    },
};

export default widgetModule;
